import { useCallback, useEffect, useRef } from 'react';

import { queryClient } from 'providers/queryClient';
import { ACTIVE_IMPORT_ID_KEY } from 'shared/widgets/RequestsBankOpsImport/hooks/useGetActiveImportId';

export const useRemoveImportCacheWithDelay = () => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const removeImportCacheWithDelay = useCallback((delay = 5000) => {
    timerRef.current = setTimeout(() => {
      queryClient.resetQueries({ queryKey: [ACTIVE_IMPORT_ID_KEY] });
    }, delay);
  }, []);

  return { removeImportCacheWithDelay };
};
